import React, { useEffect, useState } from 'react';

import { ButtonTypes, IconButton } from '@eika/button';
import { IconTypes } from '@eika/icon';

import { NameValueString } from '../../actions/types';

interface Props {
    name: string;
    label?: string;
    values: { text: string; value: number }[];
    defaultIndex: number;
    onChange: (e: NameValueString) => void;
    hideControls?: boolean;
}

const StepSelect = ({ name, label, values, defaultIndex, onChange, hideControls }: Props): JSX.Element => {
    const [currentIndex, setCurrentIndex] = useState(defaultIndex);

    useEffect(() => {
        if (currentIndex > values.length) {
            setCurrentIndex(values.length - 1);
        }
    }, [currentIndex, values]);

    const onIncrement = () => {
        const newIndex = currentIndex + 1;
        if (newIndex < values.length) {
            setCurrentIndex(newIndex);
            onChange({ name, value: String(values[newIndex].value) });
        }
    };

    const onDecrement = () => {
        const newIndex = currentIndex - 1;
        if (newIndex >= 0) {
            setCurrentIndex(newIndex);
            onChange({ name, value: String(values[newIndex].value) });
        }
    };

    return (
        <div className="step-select">
            <div className="step-select-title">{label}</div>
            <div className="step-select-value">{values[currentIndex]?.text}</div>
            {!hideControls && (
                <div className="step-select-buttons">
                    <div className="step-select-buttons__button">
                        <IconButton
                            screenReaderText="Reduser grense"
                            icon={IconTypes.MINUS_36}
                            buttonType={ButtonTypes.ICON_NEGATIVE}
                            disabled={currentIndex === 0}
                            onClick={onDecrement}
                        />
                    </div>
                    <div className="step-select-buttons__button">
                        <IconButton
                            screenReaderText="Øk grense"
                            icon={IconTypes.PLUSS_36}
                            buttonType={ButtonTypes.ICON_NEGATIVE}
                            disabled={currentIndex === values.length - 1}
                            onClick={onIncrement}
                        />
                    </div>
                </div>
            )}
        </div>
    );
};

export default StepSelect;
